/** Display order of the glossary; each key has TERM, TECH and DEF under `glossary.TERMS`. */
export const GLOSSARY_TERM_KEYS = [
	'CONVERSATION',
	'TURN',
	'HANDOFF',
	'RESULT',
	'AREA',
	'BOT_VERSION',
	'ROUTING',
	'ENGINE',
	'PROMPT',
	'GATE',
	'SHORT_CIRCUIT',
	'GROUNDING',
	'ARTICLE',
	'CHUNK',
	'PUBLICATION',
	'ANTIEXAMPLE',
	'PAUSE',
	'BREAK_GLASS',
	'TOKEN',
	'AI_SPEND',
	'TRACE',
] as const;
